// QR Kiosk v2 — amber load-error callout with an optional Retry slot.
// Ported from designer kiosk2-states.jsx `ReportsError` callout. Tokens only.
// KV2-0 ships the atom; consumers arrive in KV2-1+.
import React from "react";

export interface ErrorCalloutProps {
  title: string;
  hint?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorCallout({ title, hint, onRetry, retryLabel = "Retry" }: ErrorCalloutProps) {
  return (
    <div
      style={{
        margin: "14px 14px 0",
        borderRadius: 12,
        border: "1px solid color-mix(in oklab, var(--amber) 36%, var(--border))",
        background: "color-mix(in oklab, var(--amber) 12%, var(--card))",
        padding: "13px 14px",
        display: "flex",
        gap: 10,
        flexShrink: 0,
      }}
    >
      <span style={{ color: "var(--amber)", fontSize: 15, lineHeight: 1.2 }}>{"⚠"}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13.5, fontWeight: 700, color: "var(--ink)" }}>{title}</div>
        {hint && (
          <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 3, lineHeight: 1.5 }}>{hint}</div>
        )}
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            alignSelf: "center",
            height: 36,
            padding: "0 14px",
            borderRadius: 9,
            border: "1px solid var(--border)",
            background: "var(--card)",
            color: "var(--ink-2)",
            fontFamily: "inherit",
            fontSize: 12.5,
            fontWeight: 600,
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
}

export default ErrorCallout;
